import React, { useEffect } from 'react';
import { Block } from "@randajan/jet-react/dom/block";

import "./ShopCat.scss";
import { ShopStuff } from './ShopStuff/ShopStuff';



export const ShopCat = (props)=>{
    const { shopStuffs } = props;


    return (
        <Block className="ShopCat">
            <section className="stuffs">
                {shopStuffs.map(s=><ShopStuff key={s.id} {...s} shopCategory={props}/>)}
            </section>
        </Block>
    )
}

